module.exports = __webpack_public_path__ + "static/q12-de8a7200305cb5275b2ce79e457d501a.png";